import React from 'react';
import { BadgeCheckIcon, ShieldCheckIcon, HandshakeIcon, HeartIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
import { SectionHeading } from './SectionHeading';
import type { Localized } from '../types';
const reasons: {
  id: string;
  icon: typeof BadgeCheckIcon;
  title: Localized;
  body: Localized;
}[] = [{
  id: 'expertise',
  icon: BadgeCheckIcon,
  title: {
    en: 'Professional Expertise',
    es: 'Experiencia Profesional'
  },
  body: {
    en: 'Highly trained, background-checked cleaning professionals who follow a room-by-room checklist.',
    es: 'Profesionales capacitados y verificados que siguen una lista de verificación habitación por habitación.'
  }
}, {
  id: 'products',
  icon: ShieldCheckIcon,
  title: {
    en: 'Safe Products',
    es: 'Productos Seguros'
  },
  body: {
    en: 'Eco-friendly cleaning products that are safe for children, pets and sensitive surfaces.',
    es: 'Productos ecológicos, seguros para niños, mascotas y superficies delicadas.'
  }
}, {
  id: 'reliable',
  icon: HandshakeIcon,
  title: {
    en: 'Reliable Service',
    es: 'Servicio Confiable'
  },
  body: {
    en: 'Punctual, dependable and in uniform — the same standard on every single visit.',
    es: 'Puntuales, confiables y con uniforme: el mismo estándar en cada visita.'
  }
}, {
  id: 'satisfaction',
  icon: HeartIcon,
  title: {
    en: 'Customer Satisfaction',
    es: 'Satisfacción del Cliente'
  },
  body: {
    en: '100% satisfaction guarantee — we come back and make it right, or your money back.',
    es: 'Garantía de satisfacción del 100%: regresamos y lo corregimos, o le devolvemos su dinero.'
  }
}];
export function WhyChoose() {
  const {
    t
  } = useLanguage();
  return <section className="bg-white" data-id="element-379" data-mp="3a52kd65nzbvc">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-380" data-mp="3a1yb3udcdpxt">
        <SectionHeading kicker={t(copy.whyKicker)} title={t(copy.whyTitle)} data-id="element-381" data-mp="3640jym00gtrs" />

        <ul className="mt-12 grid grid-cols-1 gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-382" data-mp="3d6oz3u63bviq">
          {reasons.map(reason => <li key={reason.id} className="flex flex-col" data-id="element-383" data-mp="3i50bocnrsk4n">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-royal" data-id="element-384" data-mp="3n2sbdsunpaje">
                <reason.icon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-385" data-mp="3rus8ldjcdpca" />
              </span>
              <h3 className="mt-5 font-display text-base font-extrabold text-navy" data-id="element-386" data-mp="3vv3o6bwukzgw">
                {t(reason.title)}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-charcoal/70" data-id="element-387" data-mp="4nzm7vfk83fc">{t(reason.body)}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}